import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';

const FooterSection = () => {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);

  return (
    <footer className="bg-white py-20 border-t border-gray-200">
      <div className="container mx-auto px-6 md:px-12">
        {/* Social Media Section */}
        <div className="max-w-4xl mx-auto text-center space-y-8">
          <div>
            <p className="text-lg text-gray-600 mb-6">Seguir nas redes sociais:</p>
            <div className="flex flex-wrap justify-center items-center gap-8">
              <a
                href="https://www.facebook.com/BrunoRodriguesAdvancedTrainer/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-2xl md:text-3xl font-bold text-gray-800 hover:text-[#fff301] transition-colors duration-300"
              >
                Facebook
              </a>
              <a
                href="https://www.instagram.com/brunorodrigues_advancedtrainer/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-2xl md:text-3xl font-bold text-gray-800 hover:text-[#fff301] transition-colors duration-300"
              >
                Instagram
              </a>
              <a
                href="https://www.youtube.com/channel/UCIMEKBRtG7nNuDHqr2iI9kw"
                target="_blank"
                rel="noopener noreferrer"
                className="text-2xl md:text-3xl font-bold text-gray-800 hover:text-[#fff301] transition-colors duration-300"
              >
                YouTube
              </a>
            </div>
          </div>

          {/* Logo */}
          <div className="flex items-center justify-center py-8">
            <img 
              src="/images/logo.webp" 
              alt="Bruno Rodrigues Advanced Trainer" 
              className="h-32 md:h-40 w-auto drop-shadow-[0_2px_4px_rgba(0,0,0,0.3)]"
            />
          </div>

          {/* Footer Bottom */}
          <div className="border-t border-gray-200 pt-8">
            <p className="text-gray-600 mb-4">
              © 2026 Bruno Rodrigues Fit | Todos os direitos reservados | Made by{' '}
              <a 
                href="https://nual.design" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-black hover:text-gray-700 font-bold transition-colors"
              >
                Nual Design
              </a>
            </p>
            <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-500">
              <button 
                onClick={() => setPrivacyOpen(true)}
                className="hover:text-[#fff301] transition-colors cursor-pointer"
              >
                Política de privacidade
              </button>
              <button 
                onClick={() => setTermsOpen(true)}
                className="hover:text-[#fff301] transition-colors cursor-pointer"
              >
                Termos e condições
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Privacy Policy Modal */}
      <Dialog open={privacyOpen} onOpenChange={setPrivacyOpen}>
        <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold text-black">Política de Privacidade</DialogTitle>
          </DialogHeader>
          <div className="mt-4 text-gray-700 space-y-6 text-sm">
            <section>
              <h3 className="font-bold text-black mb-2">1. Identificação do Responsável pelo Tratamento</h3>
              <p>O presente website, https://brunorodriguesfit.com/, é gerido por:</p>
              <p className="mt-2">
                <strong>Bruno Rodrigues Fit</strong><br />
                Email: brunorodriguesadvancedtrainer@gmail.com<br />
                NIF: 224314300
              </p>
              <p className="mt-2">O responsável pelo tratamento de dados compromete-se a garantir a privacidade e proteção dos dados pessoais dos seus utilizadores, nos termos do Regulamento (UE) 2016/679 (RGPD).</p>
            </section>

            <section>
              <h3 className="font-bold text-black mb-2">2. Dados Pessoais Recolhidos</h3>
              <p>Podemos recolher os seguintes dados:</p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Nome</li>
                <li>Endereço de email</li>
                <li>Número de telefone</li>
                <li>Dados de faturação (se aplicável)</li>
                <li>Informações de saúde e condição física (quando fornecidas voluntariamente para efeitos de acompanhamento)</li>
                <li>Dados de navegação (cookies, IP, dispositivo)</li>
              </ul>
            </section>

            <section>
              <h3 className="font-bold text-black mb-2">3. Finalidade da Recolha de Dados</h3>
              <p>Os dados são recolhidos para:</p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Responder a pedidos de contacto</li>
                <li>Prestação de serviços de treino e acompanhamento</li>
                <li>Processamento de pagamentos</li>
                <li>Envio de informações, newsletters ou conteúdos promocionais (quando autorizado)</li>
                <li>Cumprimento de obrigações legais</li>
              </ul>
            </section>

            <section>
              <h3 className="font-bold text-black mb-2">4. Fundamento Legal</h3>
              <p>O tratamento baseia-se em:</p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Consentimento do titular dos dados</li>
                <li>Execução de contrato (prestação de serviços)</li>
                <li>Cumprimento de obrigações legais</li>
                <li>Interesse legítimo na melhoria dos serviços</li>
              </ul>
            </section>

            <section>
              <h3 className="font-bold text-black mb-2">5. Partilha de Dados</h3>
              <p>Os dados poderão ser partilhados com:</p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Plataformas de pagamento (ex: Stripe)</li>
                <li>Software de faturação certificado</li>
                <li>Serviços de email marketing</li>
                <li>Autoridades legais, quando exigido por lei</li>
              </ul>
              <p className="mt-2 font-medium">Nunca vendemos ou cedemos dados pessoais a terceiros para fins comerciais.</p>
            </section>

            <section>
              <h3 className="font-bold text-black mb-2">6. Conservação dos Dados</h3>
              <p>Os dados serão mantidos apenas pelo período necessário para:</p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Cumprimento da finalidade para a qual foram recolhidos</li>
                <li>Cumprimento de obrigações fiscais e legais</li>
              </ul>
            </section>

            <section>
              <h3 className="font-bold text-black mb-2">7. Direitos do Titular dos Dados</h3>
              <p>O utilizador tem direito a:</p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Aceder aos seus dados</li>
                <li>Retificar dados incorretos</li>
                <li>Solicitar o apagamento dos dados</li>
                <li>Limitar ou opor-se ao tratamento</li>
                <li>Retirar o consentimento a qualquer momento</li>
              </ul>
              <p className="mt-2">Para exercer os seus direitos, deverá enviar email para: brunorodriguesadvancedtrainer@gmail.com</p>
              <p className="mt-2">Pode ainda apresentar reclamação à Comissão Nacional de Proteção de Dados (CNPD).</p>
            </section>

            <section>
              <h3 className="font-bold text-black mb-2">8. Segurança</h3>
              <p>Adotamos medidas técnicas e organizativas adequadas para proteger os dados pessoais contra acesso não autorizado, perda ou divulgação indevida.</p>
            </section>

            <section>
              <h3 className="font-bold text-black mb-2">9. Cookies</h3>
              <p>Este website utiliza cookies para melhorar a experiência do utilizador. Pode configurar o seu navegador para recusar cookies, embora isso possa afetar o funcionamento do site.</p>
            </section>
          </div>
        </DialogContent>
      </Dialog>

      {/* Terms and Conditions Modal */}
      <Dialog open={termsOpen} onOpenChange={setTermsOpen}>
        <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold text-black">Termos e Condições</DialogTitle>
          </DialogHeader>
          <div className="mt-4 text-gray-700 space-y-6 text-sm">
            <section>
              <h3 className="font-bold text-black mb-2">1. Objeto</h3>
              <p>Os presentes Termos e Condições regulam a utilização do website https://brunorodriguesfit.com/ e a contratação dos serviços disponibilizados.</p>
              <p className="mt-2">Ao utilizar este website, o utilizador aceita integralmente os presentes termos.</p>
            </section>

            <section>
              <h3 className="font-bold text-black mb-2">2. Serviços Prestados</h3>
              <p>O site disponibiliza:</p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Planos de treino personalizados</li>
                <li>Acompanhamento online</li>
                <li>Programas de transformação física</li>
                <li>Consultoria na área do fitness</li>
              </ul>
              <p className="mt-2 font-medium">Os resultados dependem do compromisso individual do cliente.</p>
            </section>

            <section>
              <h3 className="font-bold text-black mb-2">3. Condições de Pagamento</h3>
              <ul className="list-disc list-inside space-y-1">
                <li>O pagamento deve ser efetuado antes do início do serviço.</li>
                <li>Os valores apresentados incluem IVA à taxa legal em vigor (se aplicável).</li>
                <li>O não pagamento implica suspensão do serviço.</li>
              </ul>
            </section>

            <section>
              <h3 className="font-bold text-black mb-2">4. Política de Cancelamento e Reembolsos</h3>
              <ul className="list-disc list-inside space-y-1">
                <li>Serviços já iniciados não são reembolsáveis.</li>
                <li>Cancelamentos devem ser comunicados por escrito.</li>
                <li>Situações excecionais serão analisadas caso a caso.</li>
              </ul>
            </section>

            <section>
              <h3 className="font-bold text-black mb-2">5. Responsabilidade</h3>
              <p>O cliente declara estar apto à prática de exercício físico.</p>
              <p className="mt-2">O Bruno Rodrigues Fit não se responsabiliza por:</p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Lesões resultantes de execução incorreta dos exercícios</li>
                <li>Omissão de informações médicas relevantes por parte do cliente</li>
                <li>Resultados não alcançados por incumprimento do plano</li>
              </ul>
              <p className="mt-2 font-medium">Recomenda-se consulta médica antes de iniciar qualquer programa de treino.</p>
            </section>

            <section>
              <h3 className="font-bold text-black mb-2">6. Propriedade Intelectual</h3>
              <p>Todo o conteúdo do site (textos, imagens, vídeos, planos de treino) é propriedade exclusiva do Bruno Rodrigues Fit e não pode ser reproduzido sem autorização.</p>
            </section>

            <section>
              <h3 className="font-bold text-black mb-2">7. Alterações</h3>
              <p>O responsável reserva-se o direito de alterar os presentes Termos e Condições a qualquer momento.</p>
            </section>

            <section>
              <h3 className="font-bold text-black mb-2">8. Lei Aplicável</h3>
              <p>Os presentes termos regem-se pela legislação portuguesa.</p>
              <p className="mt-2">Em caso de litígio, será competente o foro da comarca da área de residência do responsável pelo site.</p>
            </section>
          </div>
        </DialogContent>
      </Dialog>
    </footer>
  );
};

export default FooterSection;
